<template>
  <tr class="operator-limit-view">
    <td>
      {{ transactionLimit.transaction_limit_id }}
    </td>
    <td>
      {{ transactionLimit.type }}
    </td>
    <td>
      {{ transactionLimit.min_limit }}
    </td>
    <td>
      {{ transactionLimit.max_limit }}
    </td>
    <td>
      <v-progress-linear
        :value="dailyLimitPercent"
        color="green lighten-2"
        rounded
        height="17"
        class="mb-1 mt-1 limit-progress-bar"
      >
        {{ expenditure.current_day_amount || 0 }} / {{ transactionLimit.daily_limit || 0 }}
      </v-progress-linear>
    </td>
    <td>
      <v-progress-linear
        :value="weeklyLimitPercent"
        color="green lighten-2"
        rounded
        height="17"
        class="mb-1 mt-1 limit-progress-bar"
      >
        {{ expenditure.current_week_amount || 0 }} / {{ transactionLimit.weekly_limit || 0 }}
      </v-progress-linear>
    </td>
    <td>
      <v-progress-linear
        :value="monthlyLimitPercent"
        color="green lighten-2"
        rounded
        height="17"
        class="mb-1 mt-1 limit-progress-bar"
      >
        {{ expenditure.current_month_amount || 0 }} / {{ transactionLimit.monthly_limit || 0 }}
      </v-progress-linear>
    </td>
    <td class="actions">
      <v-icon @click="$emit('edit')">
        edit
      </v-icon>
      <v-icon @click="$emit('delete')">delete</v-icon>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    transactionLimit: {
      type: Object,
      default: () => ({})
    },
    expenditure: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['edit'],

  computed: {
    dailyLimitPercent () {
      if (!this.transactionLimit.daily_limit) return 0;
      return (this.expenditure.current_day_amount / this.transactionLimit.daily_limit) * 100
    },
    weeklyLimitPercent () {
      if (!this.transactionLimit.weekly_limit) return 0;
      return (this.expenditure.current_week_amount / this.transactionLimit.weekly_limit) * 100
    },
    monthlyLimitPercent () {
      if (!this.transactionLimit.monthly_limit) return 0;
      return (this.expenditure.current_month_amount / this.transactionLimit.monthly_limit) * 100
    },
  }
}
</script>

<style lang="scss" scoped>
.operator-limit-view {
  .limit-progress-bar {
    ::v-deep .v-progress-linear__content {
      position: relative;
    }
  }
  .actions {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
